import EncoderWavWorkerCode from './EncoderWavWorkerCode.js';
import EncoderWavWorker from './EncoderWavWorker';
import WebWorker from "./mp3worker.js";
import convertWav from "./audioConvertWav";

// HACK here because Safari does not support File|Blob.arrayBuffer()
(function () {
  //window.File.prototype.arrayBuffer = window.File.prototype.arrayBuffer || myArrayBuffer;
  window.Blob.prototype.arrayBuffer = window.Blob.prototype.arrayBuffer || myArrayBuffer;
  //window.Blob.prototype.arrayBuffer = myArrayBuffer;

  function myArrayBuffer() {
    // this: File or Blob
    //console.log("MY ARRAY BUFFER");
    //alert("MY ARRAY BUFFER");
    return new Promise((resolve) => {
      let fr = new FileReader();
      fr.onload = () => {
        resolve(fr.result);
      };
      fr.readAsArrayBuffer(this);
    })
  }
})();

export default class RecorderService {
  constructor () {
    console.log("RecorderService constructor");
    //window.AudioContext = window.AudioContext || window.webkitAudioContext
    this.AudioContext = window.AudioContext || window.webkitAudioContext

    this.em = document.createDocumentFragment()

    this.state = 'inactive'

    this.chunks = []
    this.chunkType = ''

    this.encoderMimeType = 'audio/wav'
    this.mediaEncoderMimeType = 'audio/webm'
    this.alt_mediaEncoderMimeType = 'audio/mp4';

    this.config = {
      manualEncoderId: 'wav',
      micGain: 1.0,
      processorBufferSize: 2048,
      stopTracksAndCloseCtxWhenFinished: true,
      usingMediaRecorder: typeof window.MediaRecorder !== 'undefined',
      //usingMediaRecorder: false,
      //userMediaConstraints: { audio: true }
      userMediaConstraints: { audio: { echoCancellation: false } }
    };
  }

  async concatSlideAudio (slide_mp3_data_array) {
    console.log("RecorderService concatSlideAudio",slide_mp3_data_array.length);
    //window.Blob.prototype.arrayBuffer = window.Blob.prototype.arrayBuffer || this.myArrayBuffer;
    //window.Blob.prototype.arrayBuffer = this.myArrayBuffer;
    let audioCtx = new this.AudioContext();
    let decoded_audioBuffers = [];
    for (let i = 0; i < slide_mp3_data_array.length; i++) {
      let slide_mp3_data = slide_mp3_data_array[i];
      if (!slide_mp3_data) {
        console.log(" MISSING SLIDE MP3 DATA!",i);
        continue;
      }
      
      //alert("CONCAT1");
      // HACK here because Safari does not support promise-based decodeAudioData
      let decoded_audioBuffer;
      try {
        decoded_audioBuffer = await new Promise (async (resolve, reject) => {
          audioCtx.decodeAudioData(await slide_mp3_data.arrayBuffer(),
            function(buf) {
              //alert("GOOD "+buf.length);
              resolve(buf);
            },
            function(error) {
              //alert("NOT GOOD");
              reject(error);
            }
          );
        });
      } catch (err) {
        alert("ERR! "+err);
      }
      //alert("CONCAT2");
      decoded_audioBuffers.push(decoded_audioBuffer);
      
      /*
      let decodeAudio = async () => {
        return new Promise((resolve, reject) => {
          audioCtx.decodeAudioData(await slide_mp3_data.arrayBuffer(), function(buf) {
            decoded_audioBuffers.push(buf);
            if (error) reject(error);
            resolve();
          });
        */
      /*
      let tmp_arrayBuffer = await new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.onload = x => resolve(fr.result);
        fr.readAsArrayBuffer(slide_mp3_data);
      });
      */
      //console.log("TYPE",typeof slide_mp3_data);
      
      /*
      alert("CONCAT1");
      try {
        let decoded_audioBuffer = await audioCtx.decodeAudioData(await slide_mp3_data.arrayBuffer());
        decoded_audioBuffers.push(decoded_audioBuffer);
      } catch (err) {
        alert("ERR! "+err);
      }
      alert("CONCAT2");
      */
      
      //let decoded_audioBuffer = await audioCtx.decodeAudioData(await slide_mp3_data);
      //let decoded_audioBuffer = await audioCtx.decodeAudioData(tmp_arrayBuffer);
    }
    
    let buflengh = decoded_audioBuffers.length;
    let channels = [];
    let totalDuration = 0;

    for(let a=0; a<buflengh; a++){
        channels.push(decoded_audioBuffers[a].numberOfChannels);// Store all number of channels to choose the lowest one after
        totalDuration += decoded_audioBuffers[a].duration;// Get the total duration of the new buffer when every buffer will be added/concatenated
    }

    let numberOfChannels = channels.reduce(function(a, b) { return Math.min(a, b); });// The lowest value contained in the array channels
    let tmp = audioCtx.createBuffer(numberOfChannels, audioCtx.sampleRate * totalDuration, audioCtx.sampleRate);// Create new buffer

    for (let b=0; b<numberOfChannels; b++) {
        let channel = tmp.getChannelData(b);
        let dataIndex = 0;
        for(let c = 0; c < buflengh; c++) {
            channel.set(decoded_audioBuffers[c].getChannelData(b), dataIndex);
            dataIndex += decoded_audioBuffers[c].length;// Next position where we should store the next buffer values
        }
    }

    console.log(" concatSlideAudio arrayBuffer -> wav");
    let wavBuf = convertWav(tmp, {});
    console.log(" concatSlideAudio wav -> mp3");
    let mp3Buf = await this.audioWavToMp3(wavBuf);
    let blob = new window.Blob(mp3Buf, { 'type': 'audio/mpeg' })
    
    //let blob = new window.Blob([new DataView(wavBuf)], {type: "audio/wav"});
    
    return blob;
  }

  async readChunk (chunk) {
    let fr_result = await new Promise((resolve, reject) => {
      let fr = new FileReader();
      fr.onload = x => resolve(fr.result);
      fr.readAsArrayBuffer(new window.Blob(chunk, {type: "audio/webm"}));
    });
    //console.log("YO",chunk,fr_result);
    return fr_result;
  }

  async audioWebmToWav (chunk) {
    //let e = await this.readChunk(chunk);
    //const buffer = e.target.result;
    let buffer = await this.readChunk(chunk);
    let data = await this.audioCtx.decodeAudioData(buffer);
    const wavBuf = convertWav(data, {});
    //let wavBlob = new Blob([new DataView(wavBuf)], {type: "audio/wav"});
    
    //return wavBlob;
    return wavBuf;
  }

  async audioWavToMp3 (wavBuf) {
    //let e = await this.readFile(chunk);
    //const buffer = e.target.result;
    //let data = await this.audioCtx.decodeAudioData(buffer);
    //const wavBuf = convertWav(data, {});
    const mp3Worker = new Worker(WebWorker);
    mp3Worker.postMessage({
      cmd: "init",
      config: {bitRate: 128}
    });
    mp3Worker.postMessage({cmd: "encode", rawInput: wavBuf});
    mp3Worker.postMessage({cmd: "finish"});
    let mp3Buf = await new Promise((resolve, reject) => {
      try {
        mp3Worker.onmessage = (e) => {
          if (e.data.cmd === "end") {
            //const mp3Blob = new Blob(e.data.buf, {type: "audio/mpeg"});
            //resolve(mp3Blob);
            mp3Worker.terminate();
            resolve(e.data.buf);
            
            //MediaRecorderClass.checkAndExecFn(cb, mp3Blob);
          }
        };
      } catch (error) {
        console.log("ERROR",error);
        reject(error);
      }
    });
    return mp3Buf;
  }

  async pauseRecording () {
    if (this.state !== 'recording') {
      return;
    }

    if (this.config.usingMediaRecorder) {
      this.mediaRecorder.pause();
    } else {

    }
    this.state = 'paused';
  }

  async unpauseRecording () {
    if (this.state !== 'paused') {
      return;
    }

    if (this.config.usingMediaRecorder) {
      this.mediaRecorder.resume();
    } else {

    }
    this.state = 'recording';
  }

  /* Returns promise */
  startRecording () {
    if (this.state !== 'inactive') {
      return
    }

    // This is the case on ios/chrome, when clicking links from within ios/slack (sometimes), etc.
    if (!window.navigator || !window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia) {
      alert('Sorry! Browser Not Supported. If on an iOS device, please use Safari.') // temp: helps when testing for strange issues on ios/safari
      return false;
    }

    this.audioCtx = new this.AudioContext();
    this.micGainNode = this.audioCtx.createGain();
    this.outputGainNode = this.audioCtx.createGain();

    // If not using MediaRecorder(i.e. safari and edge), then a script processor is required. It's optional
    // on browsers using MediaRecorder and is only useful if wanting to do custom analysis or manipulation of
    // recorded audio data.
    if (!this.config.usingMediaRecorder) {
      this.processorNode = this.audioCtx.createScriptProcessor(this.config.processorBufferSize, 1, 1) // TODO: Get the number of channels from mic
    }

    // Create stream destination on chrome/firefox because, AFAICT, we have no other way of feeding audio graph output
    // in to MediaRecorder. Safari/Edge don't have this method as of 2018-04.
    if (this.audioCtx.createMediaStreamDestination) {
      this.destinationNode = this.audioCtx.createMediaStreamDestination();
    }
    else {
      this.destinationNode = this.audioCtx.destination;
    }

    // Create web worker for doing the encoding
    if (!this.config.usingMediaRecorder) {
      //this.encoderWorker = new Worker('js/encoder-wav-worker.js')
      this.encoderWorker = new EncoderWavWorker(EncoderWavWorkerCode);
      
      this.encoderMimeType = 'audio/wav'

      this.encoderWorker.addEventListener('message', (e) => {
        let event = new window.Event('dataavailable');
        event.data = new window.Blob(e.data, { type: this.encoderMimeType });
        this._onDataAvailable(event);
      })
    }

    // This will prompt user for permission if needed
    return window.navigator.mediaDevices.getUserMedia(this.config.userMediaConstraints)
      .then((stream) => {
        //alert("GO MIC 1");
        this._startRecordingWithStream(stream);
      })
      .catch((error) => {
        alert('Error with getUserMedia: ' + error.message); // temp: helps when testing for strange issues on ios/safari
        console.log(error);
      })
  }

  _startRecordingWithStream (stream) {
    this.micAudioStream = stream

    this.inputStreamNode = this.audioCtx.createMediaStreamSource(this.micAudioStream)
    this.audioCtx = this.inputStreamNode.context

    // Allow optionally hooking in to audioGraph inputStreamNode, useful for meters
    if (this.onGraphSetupWithInputStream) {
      this.onGraphSetupWithInputStream(this.inputStreamNode)
    }

    this.inputStreamNode.connect(this.micGainNode)
    this.micGainNode.gain.setValueAtTime(this.config.micGain, this.audioCtx.currentTime)

    let nextNode = this.micGainNode

    this.state = 'recording'

    if (this.processorNode) {
      nextNode.connect(this.processorNode)
      this.processorNode.connect(this.outputGainNode)
      this.processorNode.onaudioprocess = (e) => this._onAudioProcess(e)
    }
    else {
      nextNode.connect(this.outputGainNode)
    }

    this.outputGainNode.connect(this.destinationNode)

    if (this.config.usingMediaRecorder) {
      if (window.MediaRecorder.isTypeSupported(this.mediaEncoderMimeType)) {
        this.mediaRecorder = new window.MediaRecorder(this.destinationNode.stream,{mimeType:this.mediaEncoderMimeType});
      } else {
        this.mediaRecorder = new window.MediaRecorder(this.destinationNode.stream,{mimeType:this.alt_mediaEncoderMimeType});
      }
      this.mediaRecorder.addEventListener('dataavailable', (evt) => this._onDataAvailable(evt))
      this.mediaRecorder.addEventListener('error', (evt) => this._onError(evt))

      this.mediaRecorder.start()
    } else {
      // Output gain to zero to prevent feedback. Seems to matter only on Edge, though seems like should matter
      // on iOS too.  Matters on chrome when connecting graph to directly to audioCtx.destination, but we are
      // not able to do that when using MediaRecorder.
      this.outputGainNode.gain.setValueAtTime(0, this.audioCtx.currentTime)
    }
    //alert("GO MIC 2");
  }

  softStopRecording() {
    // for pausing/resetting current slide
    console.log("softStopRecording",this.state,this.config.usingMediaRecorder);
    if (this.config.usingMediaRecorder) {
      //this.mediaRecorder.stop();
      //this.state = 'inactive';
      this.mediaRecorder.removeEventListener('dataavailable', (evt) => this._onDataAvailable(evt))
      this.stopRecording();
      //this.mediaRecorder.addEventListener('dataavailable', (evt) => this._onDataAvailable(evt))
    } else {
      this.stopRecording();
    }
  }

  stopRecording () {
    if (this.state === 'inactive') {
      return
    }

    this.micGainNode.gain.setTargetAtTime(0, this.audioCtx.currentTime, 0.015); // maybe get rid of click when we stop
    if (this.config.usingMediaRecorder) {
      this.state = 'inactive';
      this.mediaRecorder.stop();
    } else {
      this.state = 'inactive'
      this.encoderWorker.postMessage(['dump', this.audioCtx.sampleRate])
    }
  }

  _onAudioProcess (e) {
    //console.log("_onAudioProcess");
    if (this.config.broadcastAudioProcessEvents) {
      this.em.dispatchEvent(new window.CustomEvent('onaudioprocess', {
        detail: {
          inputBuffer: e.inputBuffer,
          outputBuffer: e.outputBuffer
        }
      }))
    }

    // Safari and Edge require manual encoding via web worker. Single channel only for now.
    // Example stereo encoderWav: https://github.com/MicrosoftEdge/Demos/blob/master/microphone/scripts/recorderworker.js
    if (!this.config.usingMediaRecorder) {
      if (this.state === 'recording') {
        if (this.config.broadcastAudioProcessEvents) {
          this.encoderWorker.postMessage(['encode', e.outputBuffer.getChannelData(0)])
        }
        else {
          //console.log("GOGO encoderWorker encode");
          this.encoderWorker.postMessage(['encode', e.inputBuffer.getChannelData(0)])
        }
      }
    }
  }

  cleanupThings () {
    console.log("RecorderService cleanupThings");
    this.chunks = []
    this.chunkType = null

    // for chrome/etc.
    if (this.destinationNode) {
      this.destinationNode.disconnect()
      this.destinationNode = null
    }
    
    // I think this is just for the fancy visuals that we are not using
    if (this.outputGainNode) {
      this.outputGainNode.disconnect()
      this.outputGainNode = null
    }

    // close iOS/safari thing
    if (this.processorNode) {
      this.processorNode.disconnect()
      this.processorNode = null
    }

    // close iOS/safari encoderWorker
    if (this.encoderWorker) {
      this.encoderWorker.postMessage(['close'])
      this.encoderWorker = null
    }

    // mic connection
    if (this.micGainNode) {
      this.micGainNode.disconnect()
      this.micGainNode = null
    }
    
    // data from mic
    if (this.inputStreamNode) {
      this.inputStreamNode.disconnect()
      this.inputStreamNode = null
    }

    if (this.config.stopTracksAndCloseCtxWhenFinished) {
      // This removes the red bar in iOS/Safari
      if (this.micAudioStream) {
        this.micAudioStream.getTracks().forEach((track) => track.stop())
        this.micAudioStream = null
      }
      if (this.audioCtx) {
        this.audioCtx.close()
        this.audioCtx = null
      }
    }    
  }

  async _onDataAvailable (evt) {
    this.chunks = []
    this.chunkType = null
    
    this.chunks.push(evt.data)
    this.chunkType = evt.data.type

    console.log("RecorderService _onDataAvailable",this.chunkType,this.state,this.chunks.length);
    if (this.state !== 'inactive') {
      return
    }

    /*
    // convert from webm -> wav -> mp3, or for safari wav -> mp3
    let mp3Buf = null;
    let wavBuf = null;
    let mp3Blob = null;
    if (this.chunkType.startsWith('audio/webm')) {
      // webm -> wav -> mp3
      //console.log("Converting webm -> mp3");
      //let webmBlob = new window.Blob(this.chunks, {type: "audio/webm"});
      //mp3Blob = await this.webmToMp3(webmBlob);
      //console.log("DONE");
      
      console.log("Converting webm -> wav");
      wavBuf = await this.audioWebmToWav(this.chunks);
      console.log("Converting wav -> mp3");
      mp3Buf = await this.audioWavToMp3(wavBuf);
      //mp3Buf = await this.audioWavToMp3(this.chunks);
    } else {
      // wav -> mp3
      //let tmp_wavBuf = await this.readChunk(this.chunks);
      wavBuf = await this.readChunk(this.chunks);
      console.log("Converting wav -> mp3");
      mp3Buf = await this.audioWavToMp3(wavBuf);
    }

    let blob = new window.Blob(mp3Buf, { 'type': 'audio/mp3' });
    //let blob = new window.Blob([new DataView(wavBuf)], {type: "audio/wav"});
    //let blob = mp3Blob;
    */
    
    let blob = new window.Blob(this.chunks, { 'type': this.chunkType });
    let blobUrl = window.URL.createObjectURL(blob);
  
    const recording = {
      ts: new Date().getTime(),
      blob,
      blobUrl: blobUrl,
      mimeType: blob.type,
      size: blob.size
    }
    console.log("RecorderService blob.size",blob.size);

    // JBB - 2/7/2020 - what does commenting this out do?
    this.cleanupThings();

    this.em.dispatchEvent(new window.CustomEvent('recording', { detail: { recording: recording } }));
  }

  _onError (evt) {
    console.log('error', evt)
    this.em.dispatchEvent(new window.Event('error'))
    alert('error:' + evt) // for debugging purposes
  }
}